import { render, staticRenderFns } from "./LinkageEdit.vue?vue&type=template&id=0dfc7876&scoped=true&"
import script from "./LinkageEdit.vue?vue&type=script&lang=js&"
export * from "./LinkageEdit.vue?vue&type=script&lang=js&"
import style0 from "./LinkageEdit.vue?vue&type=style&index=0&id=0dfc7876&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfc7876",
  null
  
)

export default component.exports